import { AxiosResponse } from 'axios';
import { environmentUtils } from 'utils';
import { ISubscriptionParams } from 'types/webpush';
import { SESSION_STORAGE_KEYS } from 'constants/defaultValues';
import AxiosInstanceBFF from './AxiosInstanceBFF';

const subscribeWebPushUrl = 'v1/web-push/subscribe';

export const subscribeWebPush = async (subscription: ISubscriptionParams): Promise<AxiosResponse<string>> => {
  const instanceId = environmentUtils.getEnvironmentInstance() || '';
  const userId = sessionStorage.getItem(SESSION_STORAGE_KEYS.USER_ID) || '';
  const { endpoint, keys, language } = subscription;
  const body = {
    instanceId,
    userId,
    endpoint,
    keys,
    language,
  };
  return AxiosInstanceBFF.post(subscribeWebPushUrl, body);
};
